var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "chat-toolbar" } },
    [
      _vm.conversation.create
        ? _c(
            "div",
            { staticClass: "flex flex-col px-4 pt-5" },
            [
              _vm.conversation.create
                ? _c(
                    "div",
                    {
                      staticClass: "soli-grey px-3 text-lg flex",
                      class: {
                        "justify-center": _vm.$vuetify.breakpoint.smAndDown,
                      },
                    },
                    [_vm._v("\n            New Message\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.conversation.create
                ? _c("SoliStudents", {
                    staticClass: "custom-autocomplete",
                    attrs: {
                      autocomplete: "",
                      multiple: "",
                      hasEmail: "",
                      chips: "",
                      deletableChips: "",
                      smallChips: "",
                      closeOnClick: "",
                      onDemand: "",
                      filled: "",
                      autofocus: "",
                      dense: false,
                      hideDetails: "auto",
                      "single-line": "",
                      disabled: _vm.disabled,
                      icon: false,
                      label: "To:",
                      value: _vm.value,
                      error: _vm.error,
                      rules: _vm.rules,
                      includeTeachers: _vm.can("Work"),
                      menuWidth: "-webkit-fill-available",
                      filter: [_vm.$page.props.auth.user.id],
                    },
                    on: {
                      input: function ($event) {
                        return _vm.$emit("input", $event)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$vuetify.breakpoint.smAndDown && _vm.conversation.create
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-4 soli-close",
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("clear")])],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.conversation.create
        ? _c(
            "div",
            {
              staticClass: "flex align-center",
              class: [_vm.$vuetify.breakpoint.smAndDown ? "pa-3" : "py-2 px-4"],
            },
            [
              _vm.$vuetify.breakpoint.smAndDown && !_vm.thread?.id
                ? _c(
                    "Link",
                    {
                      class: [_vm.$vuetify.breakpoint.xs ? "ml-3" : "ml-4"],
                      attrs: {
                        href: _vm.route("conversation.show", {
                          thread: _vm.thread?.id,
                          cursor: _vm.conversation?.cursor,
                          search: _vm.searching,
                          crmMode: Number(_vm.crmMode),
                        }),
                        "preserve-state": "",
                        only: [
                          "unreadMessageCount",
                          "index",
                          "thread",
                          "conversation",
                          "messages",
                          "messageCount",
                          "crmClient",
                          "searching",
                        ],
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.close()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("chevron_left")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.thread?.id
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ml-4",
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("chevron_left")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.conversation.name
                ? _c(
                    "div",
                    {
                      staticClass: "flex",
                      class: {
                        "ml-4 mr-2": _vm.$vuetify.breakpoint.xs,
                        "ml-5 mr-4": _vm.$vuetify.breakpoint.sm,
                        "ml-2 mr-4": _vm.$vuetify.breakpoint.mdAndUp,
                      },
                      staticStyle: { flex: "0" },
                    },
                    [
                      _vm.conversation.participants.length > 1
                        ? _c(
                            "v-badge",
                            {
                              attrs: {
                                content: _vm.conversation.participants.length,
                                overlap: "",
                                bottom: "",
                                color: "dark",
                                "offset-y": "20",
                              },
                            },
                            [
                              _c(
                                "v-avatar",
                                [
                                  _c("v-img", {
                                    attrs: {
                                      src: _vm.conversation.participants[0]
                                        .profile_photo_url,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "v-avatar",
                            {
                              attrs: {
                                size: _vm.$vuetify.breakpoint.smAndDown
                                  ? 36
                                  : 48,
                              },
                            },
                            [
                              _vm.conversation.participants[0].profile_photo_url
                                ? _c("v-img", {
                                    attrs: {
                                      src: _vm.conversation.participants[0]
                                        .profile_photo_url,
                                    },
                                  })
                                : _c(
                                    "v-icon",
                                    { attrs: { size: "48", color: "dark" } },
                                    [_vm._v("account_circle")]
                                  ),
                            ],
                            1
                          ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "soli-grey text-lg pt-0.5 font-bold text-xl whitespace-nowrap overflow-ellipsis mr-2 overflow-hidden",
                  class: [
                    _vm.conversation.name
                      ? _vm.$vuetify.breakpoint.smAndDown
                        ? "ml-4"
                        : "ml-2"
                      : null,
                  ],
                },
                [
                  _vm.thread?.id
                    ? _c("div", { staticClass: "soli-grey caption" }, [
                        _vm._v("Thread"),
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.conversation.name
                          ? _vm.conversation.name
                          : _vm.conversation.participants.length > 1
                          ? _vm.conversation.firstNameList
                          : _vm.conversation.fullNameList
                      ) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              false
                ? _c(
                    "v-menu",
                    {
                      attrs: { left: "", "offset-y": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "ml-2 text-shadow-blue",
                                      attrs: {
                                        small: "",
                                        outlined: "",
                                        icon: "",
                                        color: "accent",
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("tune"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3618989958
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "gap-2",
                              on: {
                                click: function ($event) {
                                  _vm.setThreadTexts = !_vm.setThreadTexts
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                { staticClass: "w-min" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Thread Texts"),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      "View text messages as a single thread\n                        "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-action",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: _vm.setThreadTexts
                                          ? "accent"
                                          : null,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.setThreadTexts
                                            ? "toggle_on"
                                            : "toggle_off"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.crmMode
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ml-2 text-shadow-blue",
                      attrs: {
                        icon: "",
                        small: "",
                        outlined: "",
                        color: "accent",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleCrmClient()
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          class: {
                            "flip-icon":
                              _vm.setCrmClient &&
                              _vm.$vuetify.breakpoint.mdAndUp,
                          },
                          attrs: { small: "" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.setCrmClient &&
                                _vm.$vuetify.breakpoint.mdAndUp
                                ? "menu_open"
                                : "contacts"
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasDeletedParticipants
        ? _c("v-banner", { attrs: { color: "soli-status-red" } }, [
            _c(
              "div",
              {
                staticClass:
                  "white--text flex justify-center gap-2 items-center py-0.5",
              },
              [
                _vm._v(
                  "\n            This conversation contains a deleted client and has been\n            archived.\n        "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.conversationUpdate
        ? _c("ConversationUpdate", {
            attrs: { conversation: _vm.conversation },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.conversationUpdate = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }